module.exports = __webpack_public_path__ + "static/photo-rahaman-b8c6e031cee9ac4bcdbf06a7984fadc8.jpg";